module.exports = __webpack_public_path__ + "static/media/case-03-mobile.4314734b.png";